import * as React from "react";

import { useState } from "react";
import InputField from "../../generic/inputField";
import {
  ValidateOtp,
  SendOtp,
  otpSend,
  otpValidate,
} from "../../service/serviceRequest/srApiService";
export const OtpSection = (props: any) => {
  const [otp, setOtp] = useState("");
  const [showVerify, setShowVerify] = useState<boolean>(true);
  const [error, setError] = useState("");

  const [fiveSecondOver, setfiveSecondOver] = useState(false);
  const [otpCount, setOtpCount] = useState(0);
  const [invalidOtpCount, setInvalidOtpCount] = useState(0);
  const [invalidOtpCnt, setinvalidOtpCnt] = useState(0);

  const [maxLimitExceeded, setMaxLimitExceeded] = useState(false);

  React.useEffect(() => {
    if (props.details.srType) otpSendV2();
    else sendOtp(); 
  }, []);
  React.useEffect(() => {
    if(props.showVerify === true || props.showVerify === false)
      setShowVerify(props.showVerify);
  }, [props.showVerify]);

  React.useEffect(() => {
    if (otpCount === 4) setError("OTP can be resend max 3 times.");
  }, [otpCount]);

  React.useEffect(() => {
    if (invalidOtpCount === 3) setError("Time out of 5 seconds.");
    if (!invalidOtpCount && error)
      setError(error.replace("Time out of 5 seconds.", ""));
  }, [invalidOtpCount]);

  React.useEffect(() => {
    if (invalidOtpCnt >= 10 && props.details.srType)
      setError("Maximum limit exceeds. Please try after half an hour.");
  }, [invalidOtpCnt]);

  React.useEffect(() => {
    if (error.includes("Time out of 5 seconds."))
      setTimeout(() => {
        setInvalidOtpCount(0);
      }, 5000);
  }, [error]);

  const verifyOtp = async () => {
    if (window.location.href.includes("/account-reactivation")) {
      props.otpVerified();
    } else {
      let payload = {
        otpCode: otp,
        text: "",
      };
      if (props.details.type === "mobileNo")
        Object.assign(payload, {
          mobno: "91" + props.details.mobileNo,
          email: "",
        });
      else Object.assign(payload, { email: props.details.emailId, mobno: "" });

      let verifyRes = await ValidateOtp(payload);

      if (verifyRes.sts) props.otpVerified();
      else {
        setError("Incorrect OTP");
        setInvalidOtpCount(invalidOtpCount + 1);
      }
    }
  };
  const sendOtp = async () => {
    setInvalidOtpCount(0);
    setError("");
    setfiveSecondOver(false);
    setOtpCount(otpCount + 1);
    setTimeout(() => {
      setfiveSecondOver(true);
    }, 5000);

    let payload = {
      modifyProfile: true,
      otpCode: "",
    };
    if (props.details.type === "mobileNo")
      Object.assign(payload, {
        mobno: "91" + props.details.mobileNo,
        email: "",
      });
    else Object.assign(payload, { email: props.details.emailId, mobno: "" });
    await SendOtp(payload);
  };

  const otpSendV2 = async () => {
    if (props.setLoader) props.setLoader(true);
    setInvalidOtpCount(0);
    setError("");
    setfiveSecondOver(false);
    setOtpCount(otpCount + 1);
    setTimeout(() => {
      setfiveSecondOver(true);
    }, 5000);

    const reqObj: any = {
      acTyp: props.details.acTyp && props.details.acTyp === "COMEQ" ? "EQ" : props.details.acTyp,
      reqTyp: "generate",
      sr: props.details.srType,
      srAcTyp: props.details.srAcType,
    };
    // console.log(reqObj);
    if (props.details.dpId) 
      reqObj.dpId = props.details.dpId;

    if (props.details.type === "mobileNo")
      reqObj.mobile = props.details.mobileNo;
    if (props.details.type === "emailId") 
      reqObj.email = props.details.emailId;

    if(props.details.type === "mobile_and_email") {
      reqObj.mobile = props.details.mobileNo;//"7090334840";//
      reqObj.email = props.details.emailId;//"dhanyashreeajila@gmail.com";//
    }
    if(props.details.userType)
      reqObj.userType = props.details.userType;
    if(props.details.segmentType)
      reqObj.segmentType = props.details.segmentType;

    let res = await otpSend(reqObj); 
    if (props.setLoader) props.setLoader(false);

    if (res.error && res.error.errMsg) {
      if (res.error.errCd === "SR0001") {
        setError("Maximum limit exceeds. Please try after half an hour.");
        setMaxLimitExceeded(true);
      }
    }
    

    //resp{"appID":"663051cfbac7d699a1c59b96048b50e7","config":{"app":1,"exp":1648255541931,"info":14,"prmBndExp":1641551427846},"data":{"type":"srotpResDao","msg":"SUCCESS"},"msgID":"5bf296ad-68f8-4ba4-b944-b911414ca0c1","srvTm":1648296757028}
  };

  const otpVerifyV2 = async () => {
    if (props.setLoader) props.setLoader(true);
    const reqObj: any = {
      acTyp: props.details.acTyp && props.details.acTyp === "COMEQ" ? "EQ" : props.details.acTyp,
      otp: otp,
      sr: (props.details.srType === "Normal to SMTF Fund Movement Preference") ? props.details.sr : props.details.srType
    };
    if (props.details.type === "mobileNo")
      reqObj.mobile = props.details.mobileNo;
    if (props.details.type === "emailId") 
      reqObj.email = props.details.emailId;

    if(props.details.type === "mobile_and_email") {
      reqObj.mobile = props.details.mobileNo;
      reqObj.email = props.details.emailId;
    }
    
     let verifyRes: any = await otpValidate(reqObj);
    // console.log("verifyRes", verifyRes);
    if (props.setLoader) props.setLoader(false);
    
    if (verifyRes && verifyRes.data) props.otpVerified(verifyRes.data.unId);
    else if (verifyRes.error) {
      if (invalidOtpCnt + 1 >= 10) {
        setError("Max limit exceeded. Please try again after some time.");
      } else {
        setError("Incorrect OTP");
        setInvalidOtpCount(invalidOtpCount + 1);
      }
      setinvalidOtpCnt(invalidOtpCnt + 1);
    }
    
  };

  return (
    <>
      <div className={"verify " + (props.containerClass ? props.containerClass : "")}>
        <div className="text">
          <p className={(props.otpHeader ? props.otpHeader : "")}>
            We've sent an OTP to the registered{" "}
            {(props.details.type === "mobileNo") ? "mobile no." : (props.details.type === "mobile_and_email") ? "mobile no. and email ID" : "email ID"}
          </p>
        </div>
        <div className="custom--row">
          <div className={"custom-col " + (props.inputClass ? props.inputClass : "")}>
            <InputField
              onChange={(val) => {
                if (
                  !error.includes("OTP can be resend max 3 times.") &&
                  !error.includes("Time out of 5 seconds.")
                )
                  setError("");
                setOtp(val);
              }}
              integer={true}
              defaultValue={otp}
              onBlur={() => {}}
              className="formInpCont mgT7 w-50"
              placeholder="Enter OTP"
              maxLength={4}
              required
              helpText={
                !fiveSecondOver &&
                otpCount <= 4 &&
                otpCount !== 0 &&
                otpCount !== 1
                  ? "OTP has been resent"
                  : ""
              }
              // errorText={error}
              helpTextColor="blue"
              disabled={maxLimitExceeded || invalidOtpCnt >= 10}
            ></InputField>
          </div>
          <div className="custom-col">
            {showVerify && (<button
              type="submit"
              disabled={
                !otp ||
                otp.length !== 4 ||
                invalidOtpCount === 3 ||
                props.verifyDisabled ||
                (error && !error.includes("OTP can be resend max 3 times"))
              }
              className={"btn btn-blue login-btn" + (otp ? " opacity" : "")}
              onClick={(e) => {
                if (props.details.srType) otpVerifyV2();
                else verifyOtp();
                e.preventDefault();
              }}
            >
              Verify
            </button>)}
            {!showVerify && (
              // <div className="icon-container">
                <i className="edel-icon-tick icon"></i>
              // </div>
            )}
          </div>
        </div>
        {error && <div className="help_text red error_top">{error}</div>}
        {otpCount < 4 && !maxLimitExceeded && showVerify && (
          <div className="text pd-t10 sub-text">
            <p>
              Didn't get the OTP? Shall we{" "}
              <a
                className={
                  !fiveSecondOver ||
                  maxLimitExceeded ||
                  invalidOtpCnt >= 10 ||
                  error.includes("Time out of 5 seconds")
                    ? "no-cursor"
                    : ""
                }
                onClick={(e) => {
                  if (
                    !fiveSecondOver ||
                    maxLimitExceeded ||
                    invalidOtpCnt >= 10 ||
                    error.includes("Time out of 5 seconds")
                  ) {
                    e.preventDefault();
                    return;
                  }
                  setOtp("");
                  setError("");
                  if (props.details.srType) otpSendV2();
                  else sendOtp();
                }}
              >
                Send it again?
              </a>
            </p>
          </div>
        )}
      </div>
    </>
  );
};
